/*!

=========================================================
* Light Bootstrap Dashboard PRO React - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/light-bootstrap-dashboard-pro-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { Component } from "react";
import {
  Grid,
  Row,
  Col,
  Table,
  OverlayTrigger,
  FormControl,
  ControlLabel,
  FormGroup,
  Pagination,
  Modal,
  Tooltip,
} from "react-bootstrap";
import {
  GetSubscription,
  DeleteSubscription,
  RegenerateUserToken,
  getUserToken,
  DeleteUserToken,
  getallUsers,
  getMedicationcategory,
  deleteUser,
  getRiderDistance,
  getCountry,
} from "../../../Listfunction";
// react component that creates a switch button that changes from on to off mode
import { Link, withRouter } from "react-router-dom";
import ReactTable from "react-table";

import Switch from "react-bootstrap-switch";

import LoadingSpinner from "views/Components/loadingSpinner";

import Card from "components/Card/Card.jsx";
import SweetAlert from "react-bootstrap-sweetalert";
import NotificationSystem from "react-notification-system";
import { style } from "../../../variables/Variables";
import Button from "components/CustomButton/CustomButton.jsx";
import LoadingRefreshtoken from "views/Components/loadingRefreshtoken";

import copy from "copy-to-clipboard";
import { getApiErrorMessage } from "utils/getApiErrorMessage";

class userlist extends Component {
  constructor(props) {
    super(props);
    this.state = {
      regenerateloading: false,
      user_detail: [],
      category: [],
      paginationData: [],
      nextpage: "",
      prevpage: "",
      currentPage: 1,
      nextdisabled: "1",
      prevdisabled: "1",
      tabledata: "",
      tier_name: "",
      subscription_fees: "",
      description: "",
      delivery_distance_from: "",
      delivery_distance_to: "",
      page: "",
      loading: false,
      alert: null,
      name: "",
      email: "",
      mobile: "",
      useraccess: "",
      noRecordFound: false,
      showtokenmodal: false,
      viewtoken: null,
      showregeneratetokenmodal: false,
      t_email: "",
      t_emailError: null,
      t_password: "",
      t_passwordError: null,
      errormessages: [],
      copysuccess: "",
      textToCopy: "",
      copymsg: "",
      errortokenmessages: [],
      rider_Details: [],
      showriderDetails: false,
      role: "",
      country_detail: [],
      country_code: "",
    };
    this.selecteduser = this.selecteduser.bind(this);
    this.openriderInfo = this.openriderInfo.bind(this);
    this.deleteuser = this.deleteuser.bind(this);
    this.searchdata = this.searchdata.bind(this);
    this.searchData = this.searchData.bind(this);
    this.resetSearch = this.resetSearch.bind(this);
    this.paginationinfo = this.paginationinfo.bind(this);
    this.onChange = this.onChange.bind(this);
    // this.textAreaRef = React.createRef();

    this.copyToClipboard = this.copyToClipboard.bind(this);
    this.warningWithConfirmAndCancelMessage =
      this.warningWithConfirmAndCancelMessage.bind(this);
  }
  selecteduser(cus) {
    localStorage.setItem("CustomerID", JSON.stringify(cus));

    this.props.history.push("/admin/edit-user");
  }
  componentDidMount() {
    this.setState({ _notificationSystem: this.refs.notificationSystem });

    setTimeout(
      function () {
        this.setState({ cardHidden: false });
      }.bind(this),
      700,
    );

    var token = JSON.parse(localStorage.getItem("user"));
    console.log(token, "user");
    this.setState({
      useraccess: token.role,
      role: token.role == 13 ? "8" : "",
    });

    this.searchData();

    const obj = token.token;
    getCountry(obj).then((cdata) => {
      const countrydata = cdata.data;
      this.setState({
        country_detail: countrydata,
      });
    });
  }

  handleNetworkError(position, error) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "error";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          {/* <b>Network Error</b>. */}
          <b>{getApiErrorMessage(error)}</b>.
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
  }

  handleSuccess(position) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "success";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          <b>Token</b> - Deleted Successfully .
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
  }

  handleTokenSuccess(position) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "success";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          <b>Token</b> - Regenerated Successfully .
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
  }

  handleClick(position) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "error";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          <b>something went wrong</b>.
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
  }

  opentokendetailmodal(id) {
    this.setState({ showtokenmodal: true });

    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    getUserToken(id, obj).then((res) => {
      console.log(res);
      if (res.data.success === false) {
        // this.setState({ regenerateloading: false  });

        if (res.data.length != 0) {
          var ermessage = [];
          for (var key of Object.keys(res.data)) {
            var data = res.data[key];
            ermessage.push(data);
          }
          this.setState({ errortokenmessages: ermessage });
        }
      } else if (res.data.success === true) {
        console.log(res.data.data, "token");
        var token_data = res.data.data.api_token;

        this.setState({ viewtoken: token_data });
      }
    });
  }

  closetokendetailmodal() {
    this.setState({
      showtokenmodal: false,
      viewtoken: null,
      copymsg: "",
      errortokenmessages: [],
    });
  }

  copyToClipboard() {
    this.setState({ copymsg: "copied to clipbord!" });
    copy(this.state.viewtoken);
  }

  removeUserToken(id) {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;

    DeleteUserToken(id, obj)
      .then((res) => {
        if (res.data.success === true) {
          this.handleSuccess("bl");
          this.searchData();
        } else {
          this.handleClick("bl");
        }
      })
      .catch((error) => {
        console.log(error, "== error");
        this.handleNetworkError("bl", error);
      });
  }

  openregeneratetokenmodal(refresh_token) {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    // const refresh_token = token.refresh_token
    console.log(refresh_token, "refresh token ");
    this.setState({ regenerateloading: true }, () => {
      this.setState({ errormessages: [] });
      RegenerateUserToken(refresh_token, obj)
        .then((res) => {
          console.log(res);
          if (res.data.success === false) {
            this.setState({ regenerateloading: false });

            if (res.data.data.length != 0) {
              var ermessage = [];
              for (var key of Object.keys(res.data.data)) {
                var data = res.data.data[key];
                ermessage.push(data);
              }
              this.setState({ errormessages: ermessage });
            } else {
              this.handleClick("bl");
            }
          } else if (res.data.success === true) {
            this.setState({ regenerateloading: false });
            this.handleTokenSuccess("bl");
            this.searchData();
            // this.setState({ showregeneratetokenmodal: false,t_password : '',t_email : ''  });
          } else {
            this.handleClick("bl");
          }
        })
        .catch((error) => {
          console.log(error);
          this.handleNetworkError("bl", error);
        });
    });
  }

  closeregeneratetokenmodal() {
    this.setState({
      showregeneratetokenmodal: false,
      t_email: "",
      t_password: "",
    });
  }

  onChange = (event) => {
    const target = event.target;
    const value = target.type === "select" ? target.selected : target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  };

  paginationinfo(url) {
    this.setState({ page: url });
    this.searchData();
  }

  searchdata(e) {
    this.setState({ page: "" });
    this.searchData();
  }

  resetSearch(e) {
    this.setState({
      name: "",
      email: "",
      mobile: "",
      role: this.state.useraccess == 13 ? "8" : "",
    });
    this.searchData();
  }

  searchData(e) {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    this.setState({ noRecordFound: false });

    this.setState({ loading: true }, () => {
      getallUsers(
        this.state.name,
        this.state.email,
        this.state.mobile,
        this.state.role,
        this.state.page,
        this.state.country_code,
        obj,
      ).then((response1) => {
        var data = response1.data;
        if (data.data.length == 0) {
          this.setState({ noRecordFound: true });
        }
        var $no_pages = [];
        let serach_string = "";
        for (var i = 1; i <= data.last_page; i++) {
          if (serach_string == "") {
            $no_pages.push(i);
          } else {
            $no_pages.push(i);
          }
        }

        if (data.current_page == data.last_page) {
          this.setState({ prevdisabled: null });
          this.setState({ nextdisabled: "1" });
        } else if (data.current_page == 1) {
          this.setState({ nextdisabled: null });
          this.setState({ prevdisabled: "1" });
        } else {
          this.setState({ nextdisabled: null });
          this.setState({ prevdisabled: null });
        }
        if (data.last_page == 1) {
          this.setState({ nextdisabled: 1 });
          this.setState({ prevdisabled: 1 });
        }
        if (data.length == 0) {
          $no_pages = [];
          this.setState({ nextdisabled: 1 });
          this.setState({ prevdisabled: 1 });
        }
        this.setState({ currentPage: data.current_page });
        if (data.next_page_url != null) {
          if (serach_string == "") {
            this.setState({
              nextpage: data.next_page_url.substring(
                data.next_page_url.indexOf("=") + 1,
              ),
            });
          } else {
            this.setState({
              nextpage: data.next_page_url.substring(
                data.next_page_url.indexOf("=") + 1,
              ),
            });
          }
        } else {
          this.setState({ nextpage: "#" });
        }
        if (data.prev_page_url != null) {
          if (serach_string == "") {
            this.setState({
              prevpage: data.prev_page_url.substring(
                data.prev_page_url.indexOf("?page=") + 1,
              ),
            });
          } else {
            this.setState({
              prevpage: data.prev_page_url.substring(
                data.prev_page_url.indexOf("?page=") + 1,
              ),
            });
          }
        } else {
          this.setState({ prevpage: "#" });
        }

        this.setState({ paginationData: $no_pages });

        this.setState({
          loading: false,
          user_detail: data.data,
        });
      });
    });
  }

  warningWithConfirmAndCancelMessage(id) {
    // alert('hi');
    this.setState({
      alert: (
        <SweetAlert
          warning
          style={{ display: "block", marginTop: "-100px" }}
          title="Are you sure?"
          onConfirm={() => this.deleteuser(id)}
          onCancel={() => this.hideAlert()}
          confirmBtnBsStyle="info"
          cancelBtnBsStyle="danger"
          confirmBtnText="Yes, delete it!"
          cancelBtnText="Cancel"
          showCancel
        >
          You will not be able to recover this User Detail !
        </SweetAlert>
      ),
    });
  }

  hideAlert() {
    this.setState({
      alert: null,
    });
  }

  deleteuser(id) {
    var token = JSON.parse(localStorage.getItem("user"));

    const obj = token.token;

    deleteUser(id, obj).then(() => {
      // alert('category deleted');
      // window.location.href="#/admin/medication-category";
      this.setState({
        alert: null,
      });
      this.searchData();
    });
  }

  adduser() {
    this.props.history.push("/admin/add-user");
  }

  openriderInfo(id) {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;

    getRiderDistance(obj, id)
      .then((res) => {
        if (res.success == true) {
          var rider_data = [];
          var order_wise_riderDetails = res.data.order_wise_data;
          if (order_wise_riderDetails) {
            for (
              let i = 0;
              i < Object.keys(order_wise_riderDetails).length;
              i++
            ) {
              var keys = Object.keys(order_wise_riderDetails)[i];
              var detials = {
                order_id: keys,
                distance: order_wise_riderDetails[keys.toString()],
              };
              rider_data.push(detials);
            }
          }

          this.setState({
            rider_Details: rider_data,
            showriderDetails: true,
          });
        } else {
          this.handleNetworkError(
            "bl",
            res.message || "Failed to fetch rider details",
          );
        }
      })
      .catch((error) => {
        this.handleNetworkError("bl", error);
      });
  }

  render() {
    const view = <Tooltip id="view">View Profile</Tooltip>;
    const riderInfo = <Tooltip id="view">Rider Details</Tooltip>;
    const edit = <Tooltip id="edit">Edit</Tooltip>;
    const remove = <Tooltip id="remove">Remove</Tooltip>;
    const viewtoken = <Tooltip id="viewtoken">View Token</Tooltip>;
    const removetoken = <Tooltip id="removetoken">Remove Token</Tooltip>;
    const refreshtoken = <Tooltip id="refreshtoken">Regenerate Token</Tooltip>;
    const notoken = <Tooltip id="notoken">No Token Found</Tooltip>;
    const user_detail = this.state.user_detail;
    const category = this.state.category;
    // console.log(medication_detail);
    var c = 1;
    const errormessages = this.state.errormessages;
    const errortokenmessages = this.state.errortokenmessages;
    const user_role_arr = {
      1: "SuperAdmin",
      2: "Admin",
      3: "User",
      4: "Third Party",
      5: "Rider",
      6: "Lab Partner",
      7: "Lab Rider",
      8: "Supplier",
      9: "Doctor",
      10: "Courier Partner",
      11: "Pharmacist",
      12: "Partner",
      13: "Procurement",
      14: "Insurance",
      15: "Insurance Ref",
      16: "Reviewer",
      17: "Store Manager",
      18: "Store Phamasist",
      19: "Customer Service",
      20: "Pharmacy POS User",
      21: "Fulfillment Partner",
    };

    return (
      <div className="main-content">
        <Grid fluid>
          {this.state.alert}
          {this.state.regenerateloading ? <LoadingRefreshtoken /> : ""}
          <NotificationSystem ref="notificationSystem" style={style} />

          <Row>
            <Col md={12}>
              {errormessages.length != 0 && (
                <div className=" alert alert-danger">
                  {/* {errormessages.map((data) => (
                    <React.Fragment> */}
                  <li>{errormessages}</li>
                  {/* </React.Fragment>
                  ))} */}
                </div>
              )}

              <Card
                tableFullWidth
                content={
                  <Row>
                    {this.state.useraccess == 1 ||
                    this.state.useraccess == 2 ||
                    this.state.useraccess == 13 ? (
                      <Col md={12} sm={12} lg={12} xs={12}>
                        <Col
                          md={12}
                          sm={12}
                          lg={12}
                          xs={12}
                          className="text-right"
                        >
                          <Button
                            className="w_user btn-fill fl_mb_1 fl_mb_web_1"
                            fill
                            style={{ backgroundColor: "#2b3a41" }}
                            onClick={this.adduser.bind(this)}
                          >
                            {" "}
                            Add User <i className="fa fa-plus"></i>
                          </Button>{" "}
                          &nbsp;
                        </Col>
                      </Col>
                    ) : (
                      ""
                    )}
                    <Col md={12} sm={12} lg={12} xs={12}>
                      <Col md={4} lg={2} sm={6} xs={12} className="fl_mb_1">
                        <FormControl
                          name="name"
                          value={this.state.name}
                          placeholder="Name"
                          onChange={this.onChange}
                          type="text"
                        />
                      </Col>
                      <Col md={4} lg={2} sm={6} xs={12} className="fl_mb_1">
                        <FormControl
                          name="email"
                          value={this.state.email}
                          placeholder="Email"
                          onChange={this.onChange}
                          type="text"
                        />
                      </Col>

                      {this.state.useraccess != 13 && (
                        <Col md={4} lg={2} sm={6} xs={12} className="fl_mb_1">
                          <select
                            name="role"
                            value={this.state.role}
                            onChange={(event) => {
                              this.setState({ role: event.target.value });
                            }}
                            className="form-control"
                            style={{ margin: "0.4rem" }}
                          >
                            {this.state.useraccess == 13 ? (
                              <React.Fragment>
                                <option value="0">Select Role</option>
                                <option value="8">Supplier</option>
                              </React.Fragment>
                            ) : (
                              <React.Fragment>
                                <option value="0">Select Role</option>
                                <option value="1">Super Admin</option>
                                <option value="2">Admin</option>
                                <option value="3">User</option>
                                <option value="4">Third Party</option>
                                <option value="5">Rider</option>
                                <option value="6">Lab Partner</option>
                                <option value="7">Lab Rider</option>
                                <option value="8">Supplier</option>
                                <option value="9">Doctor</option>
                                <option value="10">Courier Partner</option>
                                <option value="11">Pharmacist</option>
                                <option value="12">Partner</option>
                                <option value="13">Procurement</option>
                                <option value="14">Insurance</option>
                                <option value="15">Insurance Ref</option>
                                <option value="16">Reviewer</option>
                                <option value="17">Store Manager</option>
                                <option value="18">Store Phamasist</option>
                                <option value="19">Customer Service</option>
                                <option value="20">Pharmacy POS User</option>
                                <option value="21">Fulfillment Partner</option>
                              </React.Fragment>
                            )}
                          </select>
                        </Col>
                      )}

                      {this.state.useraccess != 13 && (
                        <Col md={4} lg={2} sm={6} xs={12} className="fl_mb_1">
                          <select
                            name="country"
                            onChange={(event) => {
                              this.setState({
                                country_code: event.target.value,
                              });
                            }}
                            className="form-control"
                            style={{ margin: "0.4rem" }}
                          >
                            <React.Fragment>
                              <option value="0">Select Country</option>
                              {this.state.country_detail.map((country_data) => (
                                <option value={country_data.country_code}>
                                  {country_data.country_name}
                                </option>
                              ))}
                            </React.Fragment>
                          </select>
                        </Col>
                      )}

                      <Col
                        md={4}
                        lg={2}
                        sm={6}
                        xs={12}
                        style={{ margin: "0.4rem" }}
                      >
                        <Button
                          style={{ backgroundColor: "#2b3a41" }}
                          fill
                          onClick={this.searchdata.bind(this)}
                        >
                          Filter
                        </Button>
                        &nbsp;&nbsp;
                        <Button
                          style={{ backgroundColor: "#2b3a41" }}
                          fill
                          onClick={this.resetSearch.bind(this)}
                        >
                          Reset
                        </Button>
                      </Col>
                    </Col>
                    {/* <Col md={2} style={{width:'160px'}}>
                  <FormControl name="delivery_distance_from" value={this.state.delivery_distance_from ||''} placeholder="Delivery Distance From" onChange={this.onChange} type="text" />
                  </Col> 
                 <Col md={2} style={{width:'160px'}}>
                  <FormControl name="delivery_distance_to" value={this.state.delivery_distance_to ||''} placeholder="Delivery Distance To" onChange={this.onChange} type="text" />
                  </Col> */}
                    <Col md={12} sm={12} lg={12} xs={12}>
                      <Table responsive>
                        <thead>
                          <tr>
                            <th>Profile Photo</th>
                            <th>Name</th>
                            <th>Email</th>
                            <th>Store</th>
                            <th>Phone</th>
                            <th>Role</th>

                            {this.state.useraccess == 1 ? (
                              <th className="text-right">Actions</th>
                            ) : (
                              ""
                            )}
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.loading ? (
                            <tr>
                              <td colspan="10">
                                <LoadingSpinner />
                              </td>
                            </tr>
                          ) : this.state.noRecordFound ? (
                            <tr>
                              <td colspan="10">
                                <center>No record found</center>
                              </td>
                            </tr>
                          ) : (
                            <React.Fragment>
                              {user_detail.map((cus) => (
                                <tr>
                                  <td>
                                    {cus.profile_picture_url != null ? (
                                      <img
                                        style={{
                                          height: "35px",
                                          width: "35px",
                                          border: "1px solid black",
                                          "border-radius": "50%",
                                        }}
                                        src={cus.profile_picture_url}
                                      ></img>
                                    ) : (
                                      ""
                                    )}
                                  </td>
                                  <td key={cus.id}>{cus.name}</td>
                                  <td>{cus.email}</td>
                                  <td>
                                    {cus.store_details && cus.store_details.name
                                      ? cus.store_details.name
                                      : ""}
                                  </td>
                                  <td>{cus.mobile}</td>
                                  <td>{user_role_arr[cus.role]}</td>

                                  {this.state.useraccess == 1 ||
                                  this.state.useraccess == 13 ? (
                                    <td
                                      colSpan={2}
                                      className="td-actions text-right"
                                    >
                                      {cus.role == "4" ? (
                                        <>
                                          {cus.api_token != null ? (
                                            <OverlayTrigger
                                              placement="top"
                                              overlay={viewtoken}
                                            >
                                              <Button
                                                simple
                                                bsStyle="info"
                                                onClick={this.opentokendetailmodal.bind(
                                                  this,
                                                  cus.id,
                                                )}
                                                bsSize="xs"
                                              >
                                                <i className="fa fa-eye" />
                                              </Button>
                                            </OverlayTrigger>
                                          ) : (
                                            <OverlayTrigger
                                              placement="top"
                                              overlay={notoken}
                                            >
                                              <Button
                                                simple
                                                bsStyle="info"
                                                bsSize="xs"
                                              >
                                                <i className="fa fa-eye" />
                                              </Button>
                                            </OverlayTrigger>
                                          )}
                                          <OverlayTrigger
                                            placement="top"
                                            overlay={removetoken}
                                          >
                                            <Button
                                              simple
                                              bsStyle="danger"
                                              onClick={this.removeUserToken.bind(
                                                this,
                                                cus.id,
                                              )}
                                              bsSize="xs"
                                            >
                                              <i className="fa fa-trash" />
                                            </Button>
                                          </OverlayTrigger>
                                          <OverlayTrigger
                                            placement="top"
                                            overlay={refreshtoken}
                                          >
                                            <Button
                                              simple
                                              bsStyle="warning"
                                              onClick={this.openregeneratetokenmodal.bind(
                                                this,
                                                cus.refresh_token,
                                              )}
                                              bsSize="xs"
                                            >
                                              <i className="fa fa-refresh" />
                                            </Button>
                                          </OverlayTrigger>
                                        </>
                                      ) : (
                                        ""
                                      )}

                                      {cus.role == "5" && (
                                        <OverlayTrigger
                                          placement="top"
                                          overlay={riderInfo}
                                        >
                                          <Button
                                            simple
                                            bsStyle="info"
                                            onClick={this.openriderInfo.bind(
                                              this,
                                              cus.id,
                                            )}
                                            bsSize="xs"
                                          >
                                            <i
                                              class="fa fa-info-circle"
                                              aria-hidden="true"
                                            ></i>
                                          </Button>
                                        </OverlayTrigger>
                                      )}

                                      <OverlayTrigger
                                        placement="top"
                                        overlay={edit}
                                      >
                                        <Button
                                          simple
                                          bsStyle="success"
                                          onClick={this.selecteduser.bind(
                                            this,
                                            cus.id,
                                          )}
                                          bsSize="xs"
                                        >
                                          <i className="fa fa-edit" />
                                        </Button>
                                      </OverlayTrigger>

                                      {this.state.useraccess != 13 && (
                                        <OverlayTrigger
                                          placement="top"
                                          overlay={remove}
                                        >
                                          <Button
                                            simple
                                            bsStyle="danger"
                                            onClick={this.warningWithConfirmAndCancelMessage.bind(
                                              this,
                                              cus.id,
                                            )}
                                            bsSize="xs"
                                          >
                                            <i className="fa fa-times" />
                                          </Button>
                                        </OverlayTrigger>
                                      )}
                                    </td>
                                  ) : (
                                    ""
                                  )}
                                </tr>
                              ))}
                            </React.Fragment>
                          )}
                        </tbody>
                      </Table>
                      {this.state.loading ? (
                        ""
                      ) : this.state.noRecordFound ? (
                        ""
                      ) : (
                        <div style={{ textAlign: "center" }}>
                          <Pagination>
                            <Pagination.First
                              onClick={this.paginationinfo.bind(
                                this,
                                this.state.prevpage,
                              )}
                              disabled={this.state.prevdisabled}
                            />
                            {this.state.paginationData.map((url) => (
                              <Pagination.Item
                                active={
                                  this.state.currentPage == c ? "1" : null
                                }
                                onClick={this.paginationinfo.bind(this, url)}
                              >
                                {c++}
                              </Pagination.Item>
                            ))}
                            <Pagination.Last
                              onClick={this.paginationinfo.bind(
                                this,
                                this.state.nextpage,
                              )}
                              disabled={this.state.nextdisabled}
                            />
                          </Pagination>
                        </div>
                      )}
                    </Col>
                  </Row>
                }
              />

              {/* token modal   */}
              <Modal
                show={this.state.showtokenmodal}
                onHide={() => this.setState({ showtokenmodal: true })}
              >
                <Modal.Header>
                  <Modal.Title>Token </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  {this.state.copymsg != "" ? (
                    <div className="alert alert-success">
                      {this.state.copymsg}
                    </div>
                  ) : (
                    ""
                  )}
                  {errortokenmessages.length != 0 && (
                    <div className=" alert alert-danger">
                      <li>{errortokenmessages}</li>
                    </div>
                  )}
                  {this.state.viewtoken != null ? (
                    <>
                      {document.queryCommandSupported("copy") && (
                        <Col md={12}>
                          <Button
                            className="btn_copy btn-fill btn"
                            onClick={this.copyToClipboard.bind(this)}
                          >
                            Copy To Clipboard
                          </Button>
                        </Col>
                      )}
                    </>
                  ) : (
                    ""
                  )}
                  <p>
                    {this.state.viewtoken != null ? (
                      <textarea
                        className="form-control"
                        disabled="disabled"
                        rows="15"
                        col="5"
                        name="textToCopy"
                        style={{ wordBreak: "break-all", "font-size": "11px" }}
                      >
                        {this.state.viewtoken}
                      </textarea>
                    ) : (
                      "No Token Found"
                    )}
                  </p>
                </Modal.Body>
                <Modal.Footer>
                  <Button
                    class="btn-color"
                    fill
                    onClick={this.closetokendetailmodal.bind(this)}
                  >
                    Close
                  </Button>
                </Modal.Footer>
              </Modal>

              <Modal
                show={this.state.showriderDetails}
                onHide={() => this.setState({ showriderDetails: false })}
              >
                <Modal.Header>
                  <Modal.Title>Rider Details </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <Table responsive>
                    <thead>
                      <tr>
                        <th>Order Id</th>
                        <th>Distace Covered</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.rider_Details.length > 0 ? (
                        this.state.rider_Details.map((rider, key) => (
                          <tr key={key}>
                            <td>{rider.order_id}</td>
                            <td>{rider.distance}</td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={2} style={{ textAlign: "center" }}>
                            {" "}
                            No order detail available
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </Modal.Body>
                <Modal.Footer>
                  <Button
                    class="btn-color"
                    fill
                    onClick={() => this.setState({ showriderDetails: false })}
                  >
                    Close
                  </Button>
                </Modal.Footer>
              </Modal>
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

export default userlist;
